import { render, staticRenderFns } from "./BankDetailsVerificationActivity.vue?vue&type=template&id=486f582a&scoped=true&"
import script from "./BankDetailsVerificationActivity.vue?vue&type=script&lang=js&"
export * from "./BankDetailsVerificationActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=486f582a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f582a",
  null
  
)

export default component.exports